/**
 * Projects assigned to a team. API uses `projects_assigned` as an array of numeric IDs;
 * older payloads used `projects` with full objects. This helper always returns `{ id }` entries.
 */

function rawAssignedList(team) {
  if (!team) {
    return [];
  }
  if (team.projects_assigned != null) {
    return team.projects_assigned;
  }
  if (team.attributes && team.attributes.projects_assigned != null) {
    return team.attributes.projects_assigned;
  }
  if (team.projects != null) {
    return team.projects;
  }
  if (team.attributes && team.attributes.projects != null) {
    return team.attributes.projects;
  }
  return [];
}

function normalizeAssignedEntry(entry) {
  if (entry == null || entry === false) {
    return null;
  }
  if (typeof entry === 'number' || typeof entry === 'string') {
    const id = Number(entry);
    return Number.isFinite(id) ? { id } : null;
  }
  if (typeof entry === 'object' && entry.id != null) {
    const id = Number(entry.id);
    return Number.isFinite(id) ? { ...entry, id } : null;
  }
  return null;
}

export function teamAssignedProjects(team) {
  const list = rawAssignedList(team);
  if (!Array.isArray(list)) {
    return [];
  }
  return list.map(normalizeAssignedEntry).filter(Boolean);
}



// WEBPACK FOOTER //
// ./src/helpers/teamAssignedProjects.js